import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const colors = {
    yellow: '#F0D34A ',
    lightgreen: 'rgb(98, 152, 91, 0.6)', 
    green: '#62985B',
};

const getBackgroundColor = (progressLevel) => {
    switch(progressLevel) {
        case (3):
            return css`
                background-color: ${colors.green};
            `   
        case (2):
            return css`
                background-color: ${colors.lightgreen}; 
            `   
        default:
            return css`
                background-color: ${colors.yellow};
            `   
    }
} 

const paintItems = (completedSteps, steps, progressLevel) => css`
    &:nth-last-child(n+${steps - completedSteps + 1}) {
        ${getBackgroundColor(progressLevel)};
    }
`

const getStepWidth = (steps) =>  {
    const stepWidth = 100 / steps; 
        return css`
            width: ${stepWidth}%;
        `
}

const Container = styled.div`
    width: auto;
    display: flex;
    border-radius: 12px;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
`
const Step = styled.div`
    height: 25px;
    ${(props) => getStepWidth( props.steps)}
    border-top: 4px solid white;
    border-bottom: 4px solid white;
    border-right: 1px solid white;
    border-left: 1px solid white;
    background-color: #EEE;

    &:first-child {
        border-left: 4px solid white;
        border-radius: 12px 0 0 12px
    }   
    &:last-child {
        border-right: 4px solid white;
        border-radius: 0 12px 12px 0
    }

    ${(props) => paintItems(props.completedSteps, props.steps, props.progressLevel)}
`

const Progressbar = ({
  steps,
  completedSteps,
  progressLevel
}) => (
    <Container>
        {Array.from(Array(steps), (e, i) => (
            <Step key={i} steps={steps} completedSteps={completedSteps} progressLevel={progressLevel}/>
        ))}
    </Container>
    )


Progressbar.propTypes = {
    steps: PropTypes.number,
    completedSteps: PropTypes.number,
    progressLevel: PropTypes.number,
}

Progressbar.defaultProps = {
    steps: 0,
    completedSteps: 0,
    progressLevel: 0,
}

export default Progressbar